import Axios from "axios";
import {
    SET_PROJECT_BUDGET_REVISION_LIST,
    UNSET_PROJECT_BUDGET_REVISION_LIST,
  } from "@/store/mutation-types";
import { getProjectBudgetRevisionList,saveUpdateProjectBudgetRevision } from "@/store/api";

// initial state
const state = {
  getProjectBudgetRevisionList: [],
};

// getters
const getters = {
  getProjectBudgetRevisionList(state) {
    return state.getProjectBudgetRevisionList;
  },
};

// mutations
const mutations = {
  [SET_PROJECT_BUDGET_REVISION_LIST](state, data) {
    state.getProjectBudgetRevisionList = data;
  },
  [UNSET_PROJECT_BUDGET_REVISION_LIST](state) {
    state.getProjectBudgetRevisionList = [];
  },
};

// actions
const actions = {
  getProjectBudgetRevisionList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getProjectBudgetRevisionList, data)
        .then(function (response) {
          commit('SET_PROJECT_BUDGET_REVISION_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PROJECT_BUDGET_REVISION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
  saveUpdateProjectBudgetRevision({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateProjectBudgetRevision, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};